import * as Headless from '@headlessui/react';
import { Spinner } from '@oysterjs/ui/spinner';
import { StopIcon } from '@heroicons/react/20/solid';
import { PaperAirplaneIcon } from '@heroicons/react/24/solid';
import { VisibilitySplitButton } from '~/components/visibility/visibility-popover';
import { type VisibilitySelectorValue } from '~/components/visibility/visibility-selector.utils';

export const CreateWorkspaceButton = (props: {
  loading?: boolean;
  onSubmit?: () => void;
  disabled?: boolean;
  stopLoading?: boolean;
  onStop?: () => void;
  visibilityPicker?: {
    value: VisibilitySelectorValue;
    onChange: (next: VisibilitySelectorValue) => void;
    disallowPrivate?: boolean;
  };
}) => {
  if (!props.loading && props.visibilityPicker) {
    return (
      <VisibilitySplitButton
        type="button"
        value={props.visibilityPicker.value}
        onChange={props.visibilityPicker.onChange}
        disallowPrivate={props.visibilityPicker.disallowPrivate}
        disabled={props.disabled}
        onClick={props.onSubmit}
        matchDisabledAppearance={props.disabled}
      >
        <PaperAirplaneIcon className="w-4 h-4" />
      </VisibilitySplitButton>
    );
  }

  return props.loading ? (
    props.onStop ? (
      <Headless.Button
        type="button"
        className="text-white rounded-full p-2 bg-primary-500 data-[disabled]:opacity-50 transition-all duration-150 ml-auto"
        onClick={props.onStop}
        disabled={props.stopLoading}
      >
        {props.stopLoading ? (
          <Spinner size="size-4" color="white" />
        ) : (
          <StopIcon className="w-4 h-4" />
        )}
      </Headless.Button>
    ) : (
      <Headless.Button
        type="button"
        className="text-white rounded-full p-2 bg-primary-500 data-[disabled]:opacity-50 transition-all duration-150"
        disabled={props.loading}
        onClick={props.onSubmit}
      >
        <Spinner size="size-4" color="white" />
      </Headless.Button>
    )
  ) : (
    <Headless.Button
      type="button"
      className="text-white rounded-full p-2 bg-primary-500 data-[disabled]:opacity-50 transition-all duration-150"
      disabled={props.disabled}
      onClick={props.onSubmit}
    >
      <PaperAirplaneIcon className="w-4 h-4" />
    </Headless.Button>
  );
};
